import { render, staticRenderFns } from "./AbsenceRequests.vue?vue&type=template&id=55080446&"
import script from "./AbsenceRequests.vue?vue&type=script&lang=js&"
export * from "./AbsenceRequests.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports